/** 公共 AI 水印素材元数据；环境识别由上层传入，避免依赖 UI 或浏览器全局状态 */
import type { AIWatermarkAsset } from './types';

/** 秀秀素材，2026-09-09 按非零 alpha 实测可见区域，排除四周透明留白 */
export const XIUXIU_AI_WATERMARK: Readonly<AIWatermarkAsset> = {
    url: 'https://xiuxiu-pro-new.meitudata.com/poster/efd76bfd360335372c03b4bcecbd2393.png',
    width: 495,
    height: 88,
    contentRect: { x: 12, y: 10, width: 440, height: 72 },
    opacity: 0.8,
};

/** RoboNeo Web 素材；可见内容边界与主站案例、无限画布使用的素材一致 */
export const ROBONEO_WEB_AI_WATERMARK: Readonly<AIWatermarkAsset> = {
    url: 'https://titan-h5.meitu.com/xiuxiu-pc/poster-editor/ai-cn-watermark.png',
    width: 720,
    height: 180,
    contentRect: { x: 42, y: 22, width: 462, height: 136 },
    // 素材自身已有透明度，与 Agent 一致，不再额外叠加 80%。
    opacity: 1,
};

/** 设计室各项目复用 Agent 网页素材及裁剪信息，避免维护另一份图 */
export const DESIGNKIT_AI_WATERMARK = ROBONEO_WEB_AI_WATERMARK;

/** RoboNeo PC 素材；去掉透明外框后按 328:60 等比缩放 */
export const ROBONEO_PC_AI_WATERMARK: Readonly<AIWatermarkAsset> = {
    url: 'https://titan-h5.meitu.com/xiuxiu-pc/poster-editor/ai-cn-watermark-pc.png',
    width: 454,
    height: 185,
    contentRect: { x: 62, y: 62, width: 328, height: 60 },
    opacity: 1,
};

/** 仅接收 URL 的旧 DOM 入口使用裁剪后的设计室素材尺寸 */
export const LEGACY_AI_WATERMARK_SIZE = { width: 462, height: 136 } as const;

/**
 * 按宿主环境选择素材，模块本身不读取 UA 或全局配置
 * @param environment - 宿主提供的端和品牌信息
 * @returns 素材 URL、原始尺寸与可见内容边界
 */
export function selectAIWatermarkAsset(
    environment: { isMobile?: boolean; isXiuXiu?: boolean; isPoster?: boolean; isClient?: boolean } = {},
) {
    if (environment.isMobile && environment.isXiuXiu && !environment.isPoster) return XIUXIU_AI_WATERMARK;
    return environment.isClient ? ROBONEO_PC_AI_WATERMARK : DESIGNKIT_AI_WATERMARK;
}
